module.exports = {"component":"app-launcher","status":"prod","display-name":"App Launcher","SLDS-component-path":"/components/app-launcher","dependencies":[{"component":"expandable-section"},{"component":"link"},{"component":"tile"}],"url-slug":"app-launcher"}


//////////////////
// WEBPACK FOOTER
// ./components/app-launcher/docs.json
// module id = 48
// module chunks = 0